
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
    name: 'SliderImages',

    components: {
        Swiper,
        SwiperSlide,

    },

    props: {
        product: {
            type: Object,
            default: () => ({}),
        },
        images: {
            type: Array,
            default: () => [],
        },
    },
    emits: [
        'openWidgetTour',
    ],
    data() {
        return {
            swiperOptions: {
                spaceBetween: 0,
                slidesPerView: 1,
                slidesPerGroup: 1,
                loop: true,

                navigation: {
                    prevEl: '.product-slider-images__button--prev',
                    nextEl: '.product-slider-images__button--next',
                },
            },
            swiperOptionsPagination: {
                spaceBetween: 10,
                slidesPerView: 5,
                slidesPerGroup: 5,
                centeredSlides: true,
                centeredSlidesBounds: true,
                centerInsufficientSlides: true,
            },

            activeSlide: 0,
        };
    },

    methods: {
        rootChangeSlide() {
            if (!this.$refs.refSwiperPagination) {
                return;
            }
            const activeIndex = this.$refs.refSwiper?.$swiper?.realIndex || 0;
            this.activeSlide = activeIndex;
            this.$refs.refSwiperPagination.$swiper.slideTo(activeIndex);
        },
        clickItemPagination(index) {
            this.$refs.refSwiper.$swiper.slideToLoop(index);
        },
        openPopUpImages() {
          const activeIndex = this.$refs.refSwiper?.$swiper?.realIndex || 0;
            this.$store.commit('pop-up-images/setImages', {
                images: this.images,
                parametrs: {
                    activeIndex: activeIndex,
                },
            });
        },
        openWidgetTour() {
          this.$emit('openWidgetTour', this.isLinkOnWidget);
        },
    },
    computed: {
        isLinkOnWidget: function () {
            return this.product.characteristics?.[0]?.characteristics?.find((item) => item.slug === 'ssylka-na-vidzhet');
        },
    },
};
